import styled from 'styled-components';

export const Inline = styled.div`
  display: flex;
`;
